import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import ReturnsPage from './list';
import ReturnDetail from './detail';

export const partsReturnsRoutes = [
  {'component': <ReturnsPage />, 'path': paths.PartsReturns},
  {'component': <ReturnDetail />, 'path': paths.PartsReturnsDetail},
];
